import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Dimension } from '../types/Dimension'
import { deleteDimension } from '../service/dimensionService'
import { getDimensionOptions } from './getDimensionOptions'
import useDeleteQueryItem from '../../../services/api/hooks/useDeleteQueryItem'

export const useDeleteDimension = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const { notification } = App.useApp()
  const options = getDimensionOptions(companyId)
  const deleteQueryItem = useDeleteQueryItem()

  if (!companyId) {
    throw new Error('Company ID is required for dimensions.')
  }

  return useMutation({
    mutationKey: ['budget', 'dimension', 'delete'],
    mutationFn: (dimensionId: Dimension['dimensionId']) => deleteDimension(companyId, dimensionId),
    onSuccess(item) {
      deleteQueryItem(item, 'dimensionId', options)
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
